module.exports = __webpack_public_path__ + "img/bank-btn.b37572b1.png";